import Request from '@/plugins/request';

export function getAdvanceRecharges(params) {
  return Request.get('advance-recharges', { params })
}

export function createAdvanceRecharge() {
  return Request.get(`advance-recharges/create`)
}

export function storeAdvanceRecharge(data) {
  return Request.post('advance-recharges', data)
}

export function updateAdvanceRecharge(id, data) {
  return Request.put(`advance-recharges/${id}`, data)
}

export function editAdvanceRecharge(id) {
  return Request.get(`advance-recharges/${id}/edit`)
}

export function destroyAdvanceRecharge(id) {
  return Request.delete(`advance-recharges/${id}`)
}

export function changeAdviceStatus(data) {
  return Request.post(`advance-recharges/change-advice-status`, data)
}

export function exportAdvanceRecharge(params) {
  return Request.get('advance-recharges/export', { params })
}
